import React from 'react';
import { useDispatch } from 'react-redux';
import { putWarehouse } from '../../../store/actions/warehouses';
import { SalesforceFormTypes, SalesforceWarehouseForm } from '../ConnectSalesforceForm/SalesforceWarehouseForm';
import { merge } from 'lodash';

export function EditSalesforceWarehouseForm({ warehouse }) {
  const dispatch = useDispatch();

  const submit = (connectionData) => {
    const dataToUpdate = {
      orders_integration_data: merge({}, warehouse.orders_integration_data, { connection_data: connectionData }),
    };
    dispatch(putWarehouse(warehouse.id, dataToUpdate));
  };

  return <SalesforceWarehouseForm warehouse={warehouse} onSubmit={submit} formType={SalesforceFormTypes.EDIT} />;
}
